export class DocketType {
  static ShawApproach = 0;
  static ShawTheatres = 1;
}
